<ion-badge class="badge" [color]="color">
  {{ planServiceTypeToShortLabel(serviceType) }}
</ion-badge>
